export default function textTabs() {
    let textTabsContainer = document.querySelectorAll('.text-tabs-grid');

    if (textTabsContainer) {

        textTabsContainer.forEach($container => {
            let $buttons = $container.getElementsByClassName("tab-button");
            let $textElements = $container.getElementsByClassName("text-tabs-text");

            if ($buttons) {

                for (let i = 0; i < $buttons.length; i++) {

                    let clickedButton = $buttons[i];
                    let showedText = clickedButton.getAttribute("data-jump");

                    clickedButton.addEventListener('click', e => {
                        e.preventDefault();

                        for (let i = 0; i < $buttons.length; i++) {
                            if ($buttons[i].classList.contains("is-active")) {
                                $buttons[i].classList.remove("is-active");
                            }
                        }

                        if ($textElements) {
                            for (let i = 0; i < $textElements.length; i++) {
                                if ($textElements[i].classList.contains("is-active")) {
                                    $textElements[i].classList.remove("is-active");
                                }

                                if ($textElements[i].id == showedText){
                                    $textElements[i].classList.add("is-active");
                                }
                            }
                        }

                        clickedButton.classList.add('is-active');
                        return false;
                    });
                }
            }
        });
    }
}
